import React, { useState } from 'react';
import { useParams, Link, useHistory } from 'react-router-dom';
import { post } from '../../../utils/api/base';
import env from '../../../Env';

const ResetPasswordToken = () => {
  const { token } = useParams();
  const history = useHistory();
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    if (newPassword !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    setLoading(true);

    try {
      await post(`${env.baseApiUrl}/api/resetpassword`, {
        token,
        newPassword,
      });

      // Redirect to /admin login with a success indicator in location state
      history.replace('/admin', { passwordReset: true });
    } catch (err) {
      const message = err?.response?.data?.message;
      setError(message || 'Failed to reset password. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="account account--not-photo">
      <div className="account__wrapper">
        <div className="account__card">
          <div className="account__head">
            <h4 className="account__subhead subhead">Set a new password</h4>
          </div>

          <form className="form" onSubmit={handleSubmit}>
            <div className="form__form-group">
              <span className="form__form-group-label">New password</span>
              <div className="form__form-group-field">
                <input
                  className="form__field"
                  type="password"
                  name="newPassword"
                  placeholder="New password"
                  value={newPassword}
                  onChange={e => setNewPassword(e.target.value)}
                  required
                  autoComplete="new-password"
                />
              </div>
            </div>

            <div className="form__form-group">
              <span className="form__form-group-label">Confirm new password</span>
              <div className="form__form-group-field">
                <input
                  className="form__field"
                  type="password"
                  name="confirmPassword"
                  placeholder="Confirm new password"
                  value={confirmPassword}
                  onChange={e => setConfirmPassword(e.target.value)}
                  required
                  autoComplete="new-password"
                />
              </div>
            </div>

            {error && (
              <div className="form__form-group">
                <div className="account__btns">
                  <span className="text-danger">{error}</span>
                </div>
              </div>
            )}

            <div className="account__btns">
              <button
                className="account__btn btn btn-primary"
                type="submit"
                disabled={loading}
              >
                {loading ? 'Resetting...' : 'Reset password'}
              </button>
            </div>

            <div className="account__have-account">
              <Link to="/admin">Back to sign in</Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordToken;
